import { Auth } from "aws-amplify"

export const getJwtToken = async () => {
    const res = await Auth.currentSession();
    const accessToken = res.getAccessToken();
    const jwtToken = accessToken.getJwtToken();
    return jwtToken;
}